<div class="card">
  <div class="card-body">
    <div class="search-row">
      <ng-container *ngIf="(facade.encrypted$ | async) && (facade.canDecrypt$ | async)">
        <ng-container *ngIf="facade.decryptingCases$ | async; else decryptionIcon">
          <div class="decryption-slot">
            <mat-spinner class="decryption-spinner" diameter="20"></mat-spinner>
          </div>
        </ng-container>
        <ng-template #decryptionIcon>
          <button
            type="button"
            mat-icon-button
            class="decryption-slot decryption-toggle"
            (click)="onToggleDecryption()"
            [attr.aria-label]="'workspaces.cases.decryption.action' | translate"
          >
            <i [ngClass]="(facade.decrypted$ | async) ? 'ri-lock-unlock-line' : 'ri-lock-line'"></i>
          </button>
        </ng-template>
      </ng-container>
      <ts-paginated-search-header
        [searchValue]="facade.searchTerm$ | async"
        (searchChanged)="onSearchTermChange($event)"
        [previousTokens]="facade.previousTokens$ | async"
        [lastItem]="facade.nextToken$ | async"
        [length]="facade.totalCaseCount$ | async"
        [pageSize]="facade.pageSize$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [disabled]="facade.loading$ | async"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        [counting]="facade.counting$ | async"
        data-cy="workspace-cases-search"
      ></ts-paginated-search-header>
    </div>
    <ng-container *ngIf="{ listErr: facade.error$ | async } as vm">
      <div *ngIf="vm.listErr" class="workspace-cases-list-error" data-cy="workspace-cases-list-error">
        <i class="ri-error-warning-line" aria-hidden="true"></i>
        <span>{{ 'workspaces.cases.list.failed' | translate }}</span>
      </div>
      <div
        *ngIf="(facade.nameEncrypted$ | async) && (facade.searchTerm$ | async)"
        @collapse
        class="encrypted-search-warning"
      >
        <i class="ri-alert-line"></i>
        {{ 'label.encrypted_casename_use_exact_term' | translate }}
      </div>
      <ts-case-list
        *ngIf="!vm.listErr"
        [items]="facade.caseItems$ | async"
        [loading]="facade.loading$ | async"
        [noCases]="facade.noItems$ | async"
        [canMigrate]="facade.canMigrateCases$ | async"
        [canCopy]="facade.canCopyCases$ | async"
        [canRemove]="facade.canRemoveCases$ | async"
        [ownCasesOnly]="facade.ownCasesOnly$ | async"
        [currentUserId]="facade.currentUserIdValue"
        [showAnalysisState]="facade.showAnalysisState$ | async"
        [columns]="facade.displayColumns"
        [activeSort]="activeSort$ | async"
        [nameSortDisabled]="nameSortDisabled$ | async"
        (selectItem)="facade.navigateToCase($event)"
        (migrateItem)="onMigrateCase($event)"
        (copyItem)="onCopyCase($event)"
        (removeItem)="onRemoveCase($event)"
        (sortChange)="onSortChange($event)"
        data-cy="workspace-cases-list"
      ></ts-case-list>
    </ng-container>
  </div>
</div>
